"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _RadioButtonModule = _interopRequireDefault(require("./RadioButton.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Note:
 * Do not wrap Radio in a label. For simplicity's sake, Radio uses an
 * internal label tag to handle click delegation to the hidden input, and
 * nesting labels is a bad idea.
 */

const RadioButton = exports.RadioButton = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    children,
    disabled = false,
    value = '',
    focused = false,
    name = 'radio',
    selectedValue,
    onChange,
    align = 'vertical',
    classNames,
    error = false,
    tabIndex = 0,
    ariaLabel = '',
    ...props
  } = _ref;
  const radioInput = /*#__PURE__*/React.createRef();
  // @ts-ignore - TS2322 - Type 'HTMLInputElement | null' is not assignable to type 'HTMLInputElement'.
  React.useImperativeHandle(forwardRef, () => radioInput.current);
  const checked = selectedValue === value;
  React.useEffect(() => {
    if (radioInput.current && focused) {
      radioInput.current.focus();
    }
  }, [focused]);
  const onWrapClickHandler = () => {
    radioInput.current?.click();
  };
  const onChangeHandler = e => {
    if (!disabled) {
      onChange && onChange(e?.target?.value);
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      onChangeHandler(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_RadioButtonModule.default.container, {
      [_RadioButtonModule.default.horizontalRadioButton]: align === 'horizontal-fixed',
      [_RadioButtonModule.default.fluidRadioButton]: align === 'horizontal-fluid',
      [_RadioButtonModule.default.containerDisabled]: disabled
    }, classNames?.wrapper),
    onClick: onWrapClickHandler
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    checked: checked,
    disabled: disabled,
    className: (0, _classify.default)(_RadioButtonModule.default.radio, {
      [_RadioButtonModule.default.unselected]: !checked && !disabled && !error,
      [_RadioButtonModule.default.selected]: checked && !disabled && !error,
      [_RadioButtonModule.default.disabled]: disabled,
      [_RadioButtonModule.default.error]: error && !disabled
    }, classNames?.radio),
    ref: radioInput,
    onChange: onChangeHandler,
    onKeyDown: onKeyDownHandler,
    tabIndex: disabled ? -1 : tabIndex,
    name: name,
    value: value || '',
    "aria-label": ariaLabel || children
  }, props)), React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    color: "secondary",
    className: (0, _classify.default)(_RadioButtonModule.default.radioLabel, {
      [_RadioButtonModule.default.labelDisabled]: disabled
    }, classNames?.label)
  }, children));
});